type IdentifiedRecord = { id: string };
type SalesDocumentSelection = IdentifiedRecord & { type?: string | null };

export function selectedDealOutcomeId(deal: IdentifiedRecord | null): string | null {
  return deal?.id ?? null;
}

export function selectedQuotationWorkspaceId(doc: SalesDocumentSelection | null): string | null {
  return doc?.type === 'quotation' ? doc.id : null;
}
